/**
 * LandingRouter — Veraso Reports is FI-only in this project.
 * (English version lives in a separate project on verasoreports.com.)
 */
import { useEffect } from "react";
import { applyLandingHead } from "@/lib/landingLang";
import Landing from "@/pages/Landing";

export default function LandingRouter() {
  useEffect(() => {
    applyLandingHead("fi");
  }, []);

  return <Landing />;
}
